const buildFounderKeyLink = (keyId) => {
  return `https://qiibeefoundation.org/qbxfdnkey-dashboard/checking-key/${keyId}`
}

const maskWalletAddress = (address, startChars = 4, endChars = 4) => {
  if (!address || typeof address !== 'string') {
    return ''
  }
  if (address.length <= startChars + endChars) {
    return address
  }
  return `${address.slice(0, startChars)}…${address.slice(-endChars)}`
}

export { buildFounderKeyLink, maskWalletAddress }
